<i18n>
{
  "ru": {
    "merchant_name": "Имя мерчанта",
    "cancelled": "Отмена",
    "last_date": "Дата доступа",
    "link_product": "Адрес продукта",
    "product_id": "ID продукта"
  },
  "en": {
    "merchant_name": "Merchant name",
    "cancelled": "cancelled",
    "last_date": "Last date",
    "link_product": "Product link",
    "product_id": "Product ID"
  }
}
</i18n>
<template>
  <div style="margin: auto;max-width: 1175px;">
    <qr-code-modal v-if="showQrCodeModal" :visible.sync="showQrCodeModal" :text="link_product" />
    <product-modal
      v-if="showProductModal"
      :visible.sync="showProductModal"
      :callback="productSaved"
      :url="productUrl"
      :id="productId"
    />
    <el-card>
      <el-form @submit.native.prevent="search">
        <el-row :gutter="20" class="users-setings-header">
          <el-col :sm="5">
            <el-input :placeholder="$t('product_id')" v-model="filter.search_form_id"></el-input>
          </el-col>
          <el-col :sm="5">
            <el-input :placeholder="$t('sku')" v-model="filter.search_form_sku"></el-input>
          </el-col>

          <el-col :sm="8">
            <el-date-picker
              v-model="filter.time"
              type="daterange"
              range-separator="|"
              :unlink-panels="true"
              :start-placeholder="$t('from')"
              :end-placeholder="$t('to')"
              align="right"
            ></el-date-picker>
          </el-col>

          <el-col :sm="6" class="aligner right">
            <el-button native-type="submit" circle type="primary">
              <i class="el-icon-search"></i>
            </el-button>
            <el-button circle type="primary" @click="add()">
              <i class="el-icon-plus"></i>
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>
        <el-table
          ref="table"
          class="small"
          :data="tableData"
          v-loading="loading"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          @sort-change="changeSort"
        >
          <el-table-column prop="id" label="Id" width="50" sortable="custom">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="billing_name"
            :label="$t('merchant_name')"
            width="120"
            sortable="custom"
            v-if="tableData.some(r => !!r.billing_name)"
          >
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.billing_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_res_name" sortable="custom" :label="$t('product_name')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.product_res_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sku" :label="$t('sku')" width="120" sortable="custom">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.sku }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price_base" width="120" :label="$t('price')" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.price_base }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date_orig" :label="$t('date_orig')" width="130" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.date_orig }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date_last" :label="$t('last_date')" width="130" sortable="custom">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.date_last }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="link_product" width="110" :label="$t('link_product')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  content="Скопировать в буфер обмена"
                >
                  <el-button type="primary" slot="reference" size="mini" circle @click="copy(scope.row)">
                    <i class="el-icon-share"></i>
                  </el-button>
                </el-popover>
                <el-button type="primary" size="mini" circle @click="qr(scope.row)">QR</el-button>
              </span>
            </template>
          </el-table-column>
          <el-table-column :width="(showDelete + showEdit) * 50 + 1">
            <template slot-scope="scope">
              <span class="responsive-column">
                <el-button
                  type="danger"
                  v-if="showDelete"
                  size="mini"
                  circle
                  @click="remove(scope.row)"
                >
                  <i class="el-icon-delete"></i>
                </el-button>
                <el-button
                  type="success"
                  v-if="showEdit"
                  size="mini"
                  circle
                  @click="edit(scope.row)"
                >
                  <i class="el-icon-edit"></i>
                </el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import QRCodeModal from '../invoices/QRCodeModal'
import ProductModal from './ProductModal'
import copy from 'copy-to-clipboard'

export default {
  name: 'products',
  components: {
    'qr-code-modal': QRCodeModal,
    'product-modal': ProductModal
  },
  data: () => ({
    pagination: {
      total: 0,
      pageSize: 25,
      currentPage: 0
    },
    filter: {
      search_field_type_site_id: 'direct',
      search_form_site_id: '',
      search_form_id: '',
      search_form_sku: '',
      time: '',
      submit: 'Поиск'
    },
    tableData: [],
    pageLinks: {},
    sortLinks: {},
    loading: false,
    showProductModal: false,
    productUrl: '',
    productId: 0,
    showQrCodeModal: false,
    showDelete: false,
    showEdit: false,
    link_product: '',
    redirectUrl: ''
  }),
  created() {
    this.loadProducts()
  },
  methods: {
    tableRowClassName(row, index) {
      return row.row.status.toString() === '1' ? '' : 'disabled-row'
    },
    copy(row) {
      copy(row.link_product)
      this.$notify.info({ message: this.$t('copied') })
    },
    qr(row) {
      this.link_product = row.link_product
      this.showQrCodeModal = true
    },
    remove(row) {
      if (this.redirectUrl) {
        this.parseProducts(apiRes.post(this.redirectUrl, {
          l: [row.id],
          acv: '',
          page: this.pageLinks[this.pagination.currentPage],
          a2: 'Удалить'
        }))
      }
    },
    add() {
      this.showProductModal = true
      this.productId = 0
      this.productUrl = apiRes.productAdd
    },
    edit(row) {
      this.showProductModal = true
      this.productId = row.id
      this.productUrl = row.url_edit
    },
    productSaved(pageVars) {
      if (pageVars) {
        this.parseProducts(apiRes.get(this.redirectUrl))
      }
    },
    search() {
      this.loadProducts()
    },
    processResponse(vars) {
      if (vars) {
        this.tableData = vars.res.records
        this.pagination = {
          total: parseInt(vars.res.results),
          currentPage: parseInt(vars.res.cpage),
          pageSize: parseInt(vars.res.limit)
        }

        if (!this.pageLinks) this.pageLinks = {}
        if (vars.paginator) {
          if (vars.paginator.end_pages) {
            Object.keys(vars.paginator.end_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.end_pages[k]
            })
          }
          if (vars.paginator.pre_pages) {
            Object.keys(vars.paginator.pre_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.pre_pages[k]
            })
          }
          if (vars.paginator.next_pages) {
            Object.keys(vars.paginator.next_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.next_pages[k]
            })
          }
        }

        // this.filter.order_field = vars.res.order
        // this.filter.order_type = vars.res.sort
        this.sortLinks = vars.order_data
        this.showDelete = vars.show_delete
        this.showEdit = vars.show_edit
      } else {
        this.tableData = []
        this.pagination = {}
      }
    },
    parseProducts(promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        this.processResponse(data.page_vars)
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadProducts() {
      const request = {}
      Object.assign(request, this.filter)
      if (request.time) {
        request.search_form_date_orig_date_from = request.time[0].toISOString().slice(0, 10)
        request.search_form_date_orig_date_to = request.time[1].toISOString().slice(0, 10)
        delete request.time
      }
      apiRes.post(apiRes.productsUrl, request, true).then((url) => {
        this.redirectUrl = url
        this.parseProducts(apiRes.get(this.redirectUrl))
      })
    },
    changePage(newPage) {
      // this.filter.page = newPage
      // this.loadProducts()
      if (this.pageLinks[newPage]) {
        this.parseProducts(apiRes.get(this.pageLinks[newPage]))
      }
    },
    changeSort({ column, prop, order }) {
      // this.filter.sort_field = prop
      // this.filter.sort_type = order === 'ascending' ? 'ASC' : 'DESC'
      // this.loadProducts()
      if (prop === 'product_res_name') prop = 'name'
      const name = `field_${prop}`
      if (this.sortLinks[name]) {
        this.parseProducts(apiRes.get(this.sortLinks[name]))
      }
    }
  }
}
</script>
